/**
 *
 * Asynchronously loads the component for HelpMain
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
